import script from "./StaxLoggedInPay.vue?vue&type=script&setup=true&lang=ts"
export * from "./StaxLoggedInPay.vue?vue&type=script&setup=true&lang=ts"

import "./StaxLoggedInPay.vue?vue&type=style&index=0&id=8e41a3e4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e41a3e4"]])

export default __exports__